export const DEFAULT_TOURISTS = { rooms: [{ adults: 2, childrenAges: [] }] };
export const isKid = (age: number): boolean => {
  return age > 1;
};
export const isInfant = (age: number): boolean => {
  return age <= 1;
};
